import React, { useMemo } from 'react';
import cn from 'classnames';

import { convertNameToRuLocale } from 'utils';
import SmartLink from '../SmartLink';
import CompetitorLogo from '../CompetitorLogo';
import './LogoTitle.scss';

const { Fragment } = React;

interface Props {
    name: string | null;
    sportId: string;
    logoUrl?: string;
    linkToMatch?: string | null;
    isLogoBeforeTeamName?: boolean;
    isLogoHidden?: boolean;
    styleName?: string;
    className?: string;
}

const LogoTitle: React.FC<Props> = ({
    name,
    logoUrl,
    isLogoHidden,
    linkToMatch,
    className,
    isLogoBeforeTeamName,
    sportId,
}) => {
    const renderBody = useMemo(() => {
        const convertedName = convertNameToRuLocale(name);

        return (
            <Fragment>
                <div
                    styleName="name"
                    className="__app-LogoTitle-name"
                    title={convertedName}
                >
                    {convertedName}
                </div>

                {!isLogoHidden && (
                    <CompetitorLogo logoUrl={logoUrl} sportId={sportId} />
                )}
            </Fragment>
        );
    }, [name, isLogoHidden, logoUrl, sportId]);

    const wrapperStyles = cn('wrapper', {
        'is-reverse': isLogoBeforeTeamName,
    });
    const wrapperCn = cn('__app-LogoTitle-link', {
        '__app-LogoTitle-is-reverse': isLogoBeforeTeamName,
    });

    return (
        <div className={cn(className, '__app-LogoTitle-wrapper')}>
            {linkToMatch ? (
                <SmartLink
                    styleName={wrapperStyles}
                    className={wrapperCn}
                    to={linkToMatch}
                >
                    {renderBody}
                </SmartLink>
            ) : (
                <div styleName={wrapperStyles} className={wrapperCn}>
                    {renderBody}
                </div>
            )}
        </div>
    );
};

export default LogoTitle;
